// src/plugins/vuetify.js
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { pt } from 'vuetify/locale'

// ⬇️ ADICIONA ISTO
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const theme1_light = {
  dark: false,
  colors: {
    primary: '#0B0E17',
    secondary: '#3D4A6D',
    warning: '#E7C02C',
    accent: '#9DA6BA',
    background_gray: '#DFDFDD',
  },
}

export default createVuetify({
  // ⬇️ ADICIONA ISTO
  components,
  directives,

  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  locale: {
    locale: 'pt',
    messages: { pt },
  },
  theme: {
    defaultTheme: 'theme1_light',
    themes: { theme1_light },
  },
})
